<div
  class="header-container"
  [class.sidebar-collapsed]="isSidebarCollapsed"
  [class.has-gate-controls]="hasGateControls"
>
  <div class="header-gate-access">
    <div class="gate-access-controls">
      <app-lane-selector
        *ngIf="showLaneSelector"
        [options]="currentLaneOptions"
        [selectedLane]="selectedCurrentLane"
        (selectedLaneChange)="onCurrentLaneChange($event)"
      >
      </app-lane-selector>
      @if (selectedGateLane; as gateLane) {
        <app-gate-button
          action="open"
          [busy]="isLaneGateBusy(gateLane.id, 'open')"
          [disabled]="isLaneGateBusy(gateLane.id)"
          (pressed)="onOpenLaneGate(gateLane)"
        >
        </app-gate-button>
        @if (laneCanClose(gateLane)) {
          <app-gate-button
            action="close"
            [busy]="isLaneGateBusy(gateLane.id, 'close')"
            [disabled]="isLaneGateBusy(gateLane.id)"
            (pressed)="onCloseLaneGate(gateLane)"
          >
          </app-gate-button>
        }
      }
    </div>
  </div>

  <div class="desktop-header">
    <div class="header-content">
      <button
        *ngIf="showHeaderAddOrderButton()"
        type="button"
        class="quick-drawer-button header-quick-action"
        (click)="onHeaderQuickPlus($event)"
        aria-label="Add order"
        title="Add order"
      >
        <img src="assets/images/plus.svg" alt="" width="20" height="20" />
      </button>
      <button
        *ngIf="showHeaderLprScanButton()"
        type="button"
        class="quick-drawer-button header-quick-action"
        (click)="onHeaderLprScan($event)"
        aria-label="Scan QR or license plate"
        title="Scan QR or license plate"
      >
        <img
          src="assets/images/scan.svg"
          alt=""
          width="22"
          height="22"
          class="header-quick-action--scan"
        />
      </button>
      <button
        *ngIf="showNotificationBell()"
        type="button"
        class="notification-bell"
        (click)="toggleNotificationDropdown($event)"
        aria-label="Notifications"
      >
        <img src="assets/images/bell.svg" alt="" />
        <span class="badge" *ngIf="notificationCount > 0">{{
          notificationCount > 49 ? '49+' : notificationCount
        }}</span>
      </button>
      <app-notification-dropdown
        *ngIf="showNotificationBell() && isNotificationDropdownOpen && !isMobileView()"
        [isOpen]="isNotificationDropdownOpen"
        (closeRequested)="closeNotificationDropdown()"
      ></app-notification-dropdown>
      <button
        type="button"
        class="user-avatar"
        (click)="toggleProfileDropdown()"
        aria-label="Profile menu"
      >
        <img *ngIf="hasProfileImage" [src]="getProfileImage()" class="avatar-image" alt="" />
        <span *ngIf="!hasProfileImage" class="avatar-initials">{{ initials }}</span>
      </button>
      <app-profile-dropdown *ngIf="isProfileDropdownOpen"></app-profile-dropdown>
    </div>
  </div>
  <div class="mobile-header">
    <img src="/assets/122.png" alt="Logo" class="mobile-logo" />
    <div class="mobile-header-content">
      <button
        *ngIf="showHeaderAddOrderButton()"
        type="button"
        class="quick-drawer-button header-quick-action"
        (click)="onHeaderQuickPlus($event)"
        aria-label="Add order"
        title="Add order"
      >
        <img src="assets/images/plus.svg" alt="" width="20" height="20" />
      </button>
      <button
        *ngIf="showHeaderLprScanButton()"
        type="button"
        class="quick-drawer-button header-quick-action"
        (click)="onHeaderLprScan($event)"
        aria-label="Scan QR or license plate"
        title="Scan QR or license plate"
      >
        <img
          src="assets/images/scan.svg"
          alt=""
          width="22"
          height="22"
          class="header-quick-action--scan"
        />
      </button>
      <button
        *ngIf="showNotificationBell()"
        type="button"
        class="notification-bell"
        (click)="toggleNotificationDropdown($event)"
        aria-label="Notifications"
      >
        <img src="assets/images/bell.svg" alt="" />
        <span class="badge" *ngIf="notificationCount > 0">{{
          notificationCount > 49 ? '49+' : notificationCount
        }}</span>
      </button>
      <app-notification-dropdown
        *ngIf="showNotificationBell() && isMobileNotificationDropdownOpen && isMobileView()"
        [isOpen]="isMobileNotificationDropdownOpen"
        (closeRequested)="closeNotificationDropdown()"
      ></app-notification-dropdown>
    </div>
    <button
      type="button"
      class="mobile-menu-icon"
      (click)="toggleMobileNav()"
      [attr.aria-label]="isMobileNavOpen ? 'Close menu' : 'Open menu'"
    >
      <img *ngIf="!isMobileNavOpen" src="assets/images/menu.svg" alt="" />
      <span *ngIf="isMobileNavOpen">Close</span>
    </button>
  </div>
</div>
<!-- Phones: the gate controls get a second header row; this keeps page content below it. -->
@if (hasGateControls) {
  <div class="header-gate-spacer" aria-hidden="true"></div>
}
